import type { WorksheetCaseGroupItem } from '@packages/clients';

import type { WorksheetCaseGroupEntity } from '../entities';

import { toWorksheetTitleEntity } from '../../titles/helpers';

/**
 * Map a {@link WorksheetCaseGroupItem} DTO to a {@link WorksheetCaseGroupEntity}.
 *
 * @param dto - the case group DTO from the worksheet titles endpoint
 * @returns the domain entity
 * @example
 * ```ts
 * const entity = toWorksheetCaseGroupEntity({
 *     groupDescription: 'Body-related worksheets',
 *     groupName: 'Body',
 *     worksheetCaseGroupId: 'grp-1',
 *     worksheetTitles: [{ displayName: 'Paint', worksheetDescription: 'Paint issues', worksheetId: 'ws-1' }],
 * });
 * ```
 */
export function toWorksheetCaseGroupEntity(dto: WorksheetCaseGroupItem): WorksheetCaseGroupEntity {
    return {
        groupDescription: dto.groupDescription,
        groupName: dto.groupName,
        worksheetCaseGroupId: dto.worksheetCaseGroupId,
        worksheetTitles: dto.worksheetTitles.map(toWorksheetTitleEntity),
    };
}
